import { memo } from 'react'

import PlaybackSpeedOptionList from '../Components/Options'
import * as Styled from './styled'

interface IProps {
  selectedValue: number | string
  handleValueClick: (value: number) => void
}

const PlaybackSpeedMenuContent: React.FC<IProps> = ({
  selectedValue,
  handleValueClick
}) => {
  return (
    <Styled.PlaybackSpeedMenuPanel>
      <PlaybackSpeedOptionList
        selectedValue={selectedValue}
        handleValueClick={handleValueClick}
      />
    </Styled.PlaybackSpeedMenuPanel>
  )
}

export default memo(PlaybackSpeedMenuContent)
